import { render, staticRenderFns } from "./liked.vue?vue&type=template&id=93c81dcc&scoped=true&"
import script from "./liked.vue?vue&type=script&lang=js&"
export * from "./liked.vue?vue&type=script&lang=js&"
import style0 from "./liked.vue?vue&type=style&index=0&id=93c81dcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c81dcc",
  null
  
)

export default component.exports